import React from 'react'

const PrintDocumemtFooter = () => {
    return (
        <div className="d-flex flex-row justify-content-end w-100 mt-4 ps-4 ">
            <div>
                <span>
                    امضا تحویل گیرنده
                </span>
            </div>
        </div>

    )
}

export default PrintDocumemtFooter